'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUploadComplete = exports.isUploadCanceled = exports.isUploadFailed = exports.isUploadSuccess = exports.activeStatuses = exports.STATUS = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

exports.getUploaderErrorMessage = getUploaderErrorMessage;
exports.getUploaderAcceptableFormats = getUploaderAcceptableFormats;
exports.getSize = getSize;
exports.formatSizeAndUnits = formatSizeAndUnits;
exports.areUnitsEqual = areUnitsEqual;
exports.getProgress = getProgress;
exports.formatCloudFilesList = formatCloudFilesList;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We can't import STATUS from fine-uploader library as it requires window object, so copy-paste it here
// TODO: check and update this part if necessary on library update
var STATUS = exports.STATUS = {
  SUBMITTING: 'submitting',
  SUBMITTED: 'submitted',
  REJECTED: 'rejected',
  QUEUED: 'queued',
  CANCELED: 'canceled',
  PAUSED: 'paused',
  UPLOADING: 'uploading',
  UPLOAD_RETRYING: 'retrying upload',
  UPLOAD_SUCCESSFUL: 'upload successful',
  UPLOAD_FAILED: 'upload failed',
  DELETE_FAILED: 'delete failed',
  DELETING: 'deleting',
  DELETED: 'deleted'
};

var activeStatuses = exports.activeStatuses = [STATUS.SUBMITTING, STATUS.SUBMITTED, STATUS.QUEUED, STATUS.UPLOADING, STATUS.UPLOAD_RETRYING, STATUS.UPLOAD_FAILED, STATUS.UPLOAD_SUCCESSFUL];

var isUploadSuccess = exports.isUploadSuccess = function isUploadSuccess(status) {
  return status === STATUS.UPLOAD_SUCCESSFUL;
};
var isUploadFailed = exports.isUploadFailed = function isUploadFailed(status) {
  return status === STATUS.UPLOAD_FAILED;
};
var isUploadCanceled = exports.isUploadCanceled = function isUploadCanceled(status) {
  return status === STATUS.CANCELED;
};
var isUploadComplete = exports.isUploadComplete = function isUploadComplete(status) {
  return isUploadSuccess(status) || isUploadFailed(status) || isUploadCanceled(status);
};

function getUploaderErrorMessage(err) {
  var t = require('i18n-universal').getT();
  var msg = err;
  switch (err) {
    case 'tooManyFilesError':
      msg = t('Too many files');break;
    default:
      msg = err;break;
  }

  return msg;
}

function getUploaderAcceptableFormats(type) {
  var supportedFormats = _config2.default.app.uploaderSupportedFormats[type] || _config2.default.app.uploaderSupportedFormats.audio;
  return supportedFormats.map(function (val) {
    return '.' + val;
  }).join(', ');
}

function getSize(uploader, id) {
  var res = 0;
  if ((0, _isFinite2.default)(id)) {
    res = uploader.methods.getSize(id);
  } else {
    var filter = { status: activeStatuses };
    var uploads = uploader.methods.getUploads(filter);
    uploads.map(function (upload) {
      return res += upload.size;
    });
  }

  return (0, _isFinite2.default)(res) ? res : null;
}

function formatSizeAndUnits(size) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { byte: 'B', kilobyte: 'KB', megabyte: 'MB', gigabyte: 'GB', terabyte: 'TB' };

  var formattedSize = void 0;
  var formattedUnits = void 0;

  if (size < 1e+3) {
    formattedSize = size;
    formattedUnits = units.byte;
  } else if (size >= 1e+3 && size < 1e+6) {
    formattedSize = (size / 1e+3).toFixed(2);
    formattedUnits = units.kilobyte;
  } else if (size >= 1e+6 && size < 1e+9) {
    formattedSize = (size / 1e+6).toFixed(2);
    formattedUnits = units.megabyte;
  } else if (size >= 1e+9 && size < 1e+12) {
    formattedSize = (size / 1e+9).toFixed(2);
    formattedUnits = units.gigabyte;
  } else {
    formattedSize = (size / 1e+12).toFixed(2);
    formattedUnits = units.terabyte;
  }

  return { formattedSize: formattedSize, formattedUnits: formattedUnits };
}

function areUnitsEqual(units1, units2) {
  var keys1 = (0, _keys2.default)(units1);

  if (keys1.length === (0, _keys2.default)(units2).length) {
    return keys1.every(function (key1) {
      return units1[key1] === units2[key1];
    });
  }

  return false;
}

function getProgress(bytesUploaded, totalSize) {
  return totalSize ? Math.ceil(100 * bytesUploaded / totalSize) : null;
}

function formatCloudFilesList(files, service, fields) {
  var formattedList = [];
  var links = [];

  files.map(function (file) {
    var fileObject = { service: service };
    (0, _entries2.default)(fields).map(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          formattedField = _ref2[0],
          serviceField = _ref2[1];

      fileObject[formattedField] = file[serviceField];
    });
    formattedList.push(fileObject);

    links.push(fileObject.link);
  });

  return { files: formattedList, links: links };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/uploads.js
// module id = 112
// module chunks = 1